<template>
    <div class="flex colorpicker" ref="picker">
        <span class="colorpicker__picker" :style="{'background-color': selectedColor}"></span>
        <span class="colorpicker__name">{{colorName}}</span>
    </div>
</template>

<script>
const ntc = require('ntcjs');
import '@simonwep/pickr/dist/themes/nano.min.css';      // 'nano' theme
import Pickr from '@simonwep/pickr';

export default {
    props: ['value'],
    data() {
        return {
            triggerChange: true,
            pickerInstance: null,
            colorName: ntc.name(this.value)[1]
        };
    },

    computed: {
        selectedColor() {
            return this.value;
        }
    },

    mounted() {
        this.pickerInstance = Pickr.create({
            el: this.$refs.picker,
            theme: 'nano', // or 'monolith', or 'nano'
            position: 'top',
            useAsButton: true,
            lockOpacity: true,
            default: this.value,
            adjustableNumbers: false,
            swatches: [
                'rgba(244, 67, 54, 1)',
                'rgba(233, 30, 99, 1)',
                'rgba(156, 39, 176, 1)',
                'rgba(103, 58, 183, 1)',
                'rgba(63, 81, 181, 1)',
                'rgba(33, 150, 243, 1)',
                'rgba(3, 169, 244, 1)',
                'rgba(0, 188, 212, 1)',
                'rgba(0, 150, 136, 1)',
                'rgba(76, 175, 80, 1)',
                'rgba(139, 195, 74, 1)',
                'rgba(205, 220, 57, 1)',
                'rgba(255, 235, 59, 1)',
                'rgba(255, 193, 7, 1)'
            ],
            components: {
                // Main components
                preview: true,
                opacity: false,
                hue: true,

                // // Input / output Options
                interaction: {
                    input: true,
                    hex: false,
                    rgba: false,
                    hsla: false,
                    hsva: false,
                    cmyk: false,
                    save: false,
                    clear: false,
                }
            }
        }).on('change', (color, source, instance) => {
            var code = '#' + color.toHEXA().join('');

            if (this.triggerChange) {
                this.$emit('change', code, this.triggerChange);
                this.$emit('input', code, this.triggerChange);
            }

            this.triggerChange = true;
        })
    },

    methods: {
        openPicker() {
            this.pickerInstance.show();
        },

        closePicker() {
            this.pickerInstance.hide();
        }
    },

    watch: {
        value() {
            this.triggerChange = false;
            this.pickerInstance.setColor(this.value);
            this.colorName = ntc.name(this.value)[1];
        }
    }
};
</script>
